// Экземпляр notification из antd <App>. Статические notification.* создают detached React-root,
// который при монтировании роняет соседние порталы (в т.ч. модалку реаутентификации). Держим
// экземпляр из <App> (рендерит holder внутри дерева) и вызываем его из любого места — в т.ч.
// из утилит и connect-компонентов вне поддерева <App>.

let api = null;

// Вызывается мостом под <App>; см. NotificationBridge в components/Root.
export const setNotificationApi = (instance) => {
  api = instance;
};

// Прокси к актуальному экземпляру; пока <App> не смонтирован — no-op.
export const appNotification = {
  success: (config) => api?.success(config),
  info: (config) => api?.info(config),
  warning: (config) => api?.warning(config),
  error: (config) => api?.error(config),
  close: (key) => api?.destroy(key),
};
